
export default {
  props: {
    show: {type: Boolean, default: false},
    blur: {type: Boolean, default: false},
    duration: {type: Number, default: 200},
    zIndex: {type: [Number, String], default: 1000}
  }
}
